import React, { Fragment, useEffect, useState } from "react";
import About3 from "../../components/about3/about3";
import BlogSection from "../../components/BlogSection/BlogSection";
import CtaSection from "../../components/ctaSection/ctaSection";
import Footer from "../../components/footer/Footer";
import FunFact from "../../components/FunFact/FunFact";
import Hero2 from "../../components/hero2/Hero2";
import Navbar2 from "../../components/Navbar2/Navbar2";
import ProjectSection2 from "../../components/ProjectSection2/ProjectSection2";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import TeamSection from "../../components/TeamSection/TeamSection";
import Testimonial from "../../components/Testimonial/Testimonial";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import abimg from "../../images/about.jpg";
import PartnerSectionS2 from "../../components/PartnerSection2/PartnerSectionS2";
import { getProjects } from "../../api/project";
import { getHeros } from "../../api/Heros";
import { getPartners } from "../../api/Partner";
import StarLoader from "../../components/loader/StarLoader";
import { getTeams } from "../../api/team";

const HomePage2 = () => {
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [partners, setPartners] = useState([]);
  const [teams, setTeams] = useState([]);
  const [heros, setHeros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDatas() {
      try {
        const [projectData, heroData, partnerData, teamData] =
          await Promise.all([
            getProjects(),
            getHeros(),
            getPartners(),
            getTeams(),
          ]);
        setProjects(projectData);
        setHeros(heroData);
        setPartners(partnerData);
        setTeams(teamData);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
        setLoadingProjects(false);
      }
    }
    fetchDatas();
  }, []);

  if (loading) {
    return <StarLoader />;
  }

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <Hero2 heros={heros} />
      <About3 abimg={abimg} />
      <ServiceSection />
      <FunFact />
      <TeamSection teams={teams} />
      {!loadingProjects && projects.length > 0 && (
        <ProjectSection2 projects={projects} />
      )}
      <Testimonial />
      <BlogSection />
      <ContactInfo />
      <CtaSection />
      <PartnerSectionS2 partners={partners} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage2;
